import React from 'react';
import Reflux from 'reflux';
import FormItemContainer from './FormItemContainer';

import FormItemUtil from '../utils/FormItemUtil';
import ResizeActions from '../actions/ResizeActions';
import {CmdUpdateControlPropertyStore,CmdUpdateControlLabelStore,UpdateGroupCollapseStateStore} from '../stores/CmdTypeStore';
require('../styles/FormItemGroupStyle.css');

class FormItemGroup extends FormItemContainer
{
	constructor(props)
	{
		super(props);
		this.state.label = this.props.label;
		this.state.hasBorder = this.props.hasBorder;
		this.unsubscribeCmdUpdateControlPropertyStore = CmdUpdateControlPropertyStore.listen(this.onCmdUpdateControlProperty.bind(this));
		this.unsubscribeCmdUpdateControlLabelStore = CmdUpdateControlLabelStore.listen(this.onCmdUpdateControlLabel.bind(this));
		this.unsubscribeUpdateGroupCollapseStateStore = UpdateGroupCollapseStateStore.listen(this.onUpdateGroupCollapseStateStore.bind(this));
	}

	
	componentWillUnmount()
	{
		this.unsubscribeCmdUpdateControlPropertyStore();
		this.unsubscribeCmdUpdateControlLabelStore();
	}

	onCmdUpdateControlLabel(name,_label,moduleInstanceId)
	{
		if(this.props.showLabel && name == this.props.xml.name && this.props.moduleInstanceId == moduleInstanceId)
		{
			this.setState({label:_label});
		}
	}

	onUpdateGroupCollapseStateStore(arg)
	{
		if(arg && arg.hasOwnProperty(this.props.xml.name))
		{
			let value = arg[this.props.xml.name];
			if($(this.containerComponent).hasClass("expand") && value == false)
			{
				$(this.containerComponent).removeClass("expand").css("flex-grow",0);
				$(this.titleNode).css("width",$(this.titleNode).width()+'px');
				$(this.caretNode).attr("class","fa fa-caret-left");
				$(this.gotGroupNode).slideUp(function(){
					ResizeActions.groupSlide();
				});

			}
			else if(!$(this.containerComponent).hasClass("expand") && value == true)
			{
				$(this.containerComponent).addClass("expand").css("flex-grow",this.origFlexGrow);
				$(this.titleNode).css("width",'');
				$(this.caretNode).attr("class","fa fa-caret-down");
				ResizeActions.groupSlide("pre");
				$(this.gotGroupNode).slideDown(function(){
					ResizeActions.groupSlide();
				});
			}	
		}
	}

	onCmdUpdateControlProperty(name,property,value,moduleInstanceId)
	{
		if(name != this.props.xml.name || this.props.moduleInstanceId != moduleInstanceId)
			return;
		if(property == ControlPropertyConst.HASBORDER)
		{
			this.setState({hasBorder:value})
			/*if(value)
			{
				$(this.containerComponent).css({border:"solid 1px #ccc",margin:"1px"});
			}
			else
			{
				$(this.containerComponent).css({border:"none",margin:"1px"});
			}*/
		}
	}
	//因折叠不属于状态(动态效果) label等改变最好不支持或者不使用setState
	fold()
	{
		if($(this.containerComponent).hasClass("expand"))
		{
			$(this.containerComponent).removeClass("expand").css("flex-grow",0);
			$(this.titleNode).css("width",$(this.titleNode).width()+'px');
			$(this.caretNode).attr("class","fa fa-caret-left");
			$(this.gotGroupNode).slideUp(function(){
				ResizeActions.groupSlide();
			});

		}
		else
		{
			$(this.containerComponent).addClass("expand").css("flex-grow",this.origFlexGrow);
			$(this.titleNode).css("width",'');
			$(this.caretNode).attr("class","fa fa-caret-down");
			ResizeActions.groupSlide("pre");
			$(this.gotGroupNode).slideDown(function(){
				ResizeActions.groupSlide();
			});
		}	
	}

	componentDidMount()
	{
		super.componentDidMount();
		let layout = this.props.xml.Properties.Layout.Value;
		if(layout != 'vertical')
			return;
		var maxWidths = [];
		ResizeActions.getSubFieldGroupMaxWidth(this.props.xml.id,maxWidths);
		if(maxWidths.length>1)
		{
			var maxWidth = 0;
			for(let i = 0;i<maxWidths.length;i++)
			{
				if(maxWidths[i] > maxWidth)
				{
					maxWidth = maxWidths[i];
				}
			}
			ResizeActions.setSubFieldGroupMaxWidth(this.props.xml.id,maxWidth);
		}

	}



	render()
	{
		let parent = this.props.xml;
		let _id = parent.name?parent.name:parent.id;
		let children = parent.FormItem;
		let layout = parent.Properties.Layout.Value;
		let that = this;
		let list = children.map(function(item){
			return FormItemUtil.getFormItemInstance(that.props.menuItemId,that.props.formId,item,parent,that.props.forLookup);
  		 });
		
		var _style = Object.assign({},this.props.customStyle);
		
		
		if(!this.props.showLabel)
		{
			if(this.state.visible == false)
				if(this.state.hideInVisible == true) _style.display="none"; else _style.visibility="hidden";
			if(this.state.hasBorder)
			{
				_style.border = "solid 1px #ccc";
				if(this.props.parentLayout == "vertical")
				{
					_style.marginTop = _style.marginBottom = this.props.isGroupQuery?'4px':'1px';
				}
				else
				{
					_style.marginLeft = _style.marginRight = this.props.isGroupQuery?'4px':'1px';
				}
			}
			else
			{
				_style.border = "none";
			}
			//_style.borderTop = "solid 1px #ccc !important";
			return (<div data-xmlid={this.props.xml.id} id={_id} 
						ref={node => {
							try
							{
								for(let styleK in _style)
								{
									let styleV = _style[styleK];
									let importantIndex = styleV.indexOf("!important");
									if(importantIndex != -1)
									{
										node.style.setProperty(_style["orig-"+styleK], styleV.substr(0,importantIndex), 'important');
									}
								}
							}
							catch(e)
							{
								console.log("当前页面行内自定义css未能生效");
							}	
							this.containerComponent = node;
						}} 
						style={_style} className={layout=="vertical"?"verticalList FormItemGroup":"horizontalList FormItemGroup"}>{list}</div>);	
		}
		else
		{
			let outStyle = {display:'flex',flex:'0 0 auto',overflow:'auto',flexDirection:'column'};
			if(this.state.visible == false)
				if(this.state.hideInVisible == true) outStyle.display="none"; else outStyle.visibility="hidden";
			if(_style && _style.flexGrow)outStyle.flexGrow = _style.flexGrow;
			if(_style && _style.width)outStyle.width = _style.width;
			if(_style && _style.height)outStyle.height = _style.height;
			if(_style && _style.alignSelf)outStyle.alignSelf = _style.alignSelf;
			if(_style)_style.paddingTop = "6px";
			this.origFlexGrow = outStyle.flexGrow?outStyle.flexGrow:0;
			let h4Style = {fontSize:'15px',paddingLeft:'10px',borderLeft:'3px solid rgb(85, 85, 85)',marginBottom:'2px'};
			let innerStyle = {textAlign:'left',borderBottom:'solid 1px #ccc'};

			if(this.state.hasBorder)
			{
				outStyle.border = "solid 1px #ccc";
				outStyle.margin = this.props.isGroupQuery?'2px':'1px';
			}
			if(this.props.foldable)
			{
				let _className = "";let caretNodeClass = "";
				if(this.props.expand)
				{
					_className = "expand";caretNodeClass = "fa fa-caret-down";
				}
				else
				{
					outStyle.flexGrow = 0;caretNodeClass = "fa fa-caret-left";
				}
				delete _style.width;_style.flexGrow = 100;
				return (
					<div id={_id} data-xmlid={this.props.xml.id} className={"FormItemGroupFoldable "+_className} ref={node => this.containerComponent = node} style={outStyle}>
						<div className="box-header with-border" style={innerStyle} ref={node => this.titleNode = node}>
							<h4 className="box-title" style={h4Style}>{this.state.label}</h4>
							<i className={caretNodeClass} onClick={this.fold.bind(this)} ref={node => this.caretNode = node} style={{fontSize:'1.2em',position:'absolute',right:'2px',cursor:'pointer'}}></i>
						</div>
						<div style={_style} ref={node => this.gotGroupNode = node} className={layout=="vertical"?"verticalList":"horizontalList"}>{list}</div>
					</div>	
				);
			}
			else
			{
				delete _style.width;_style.flexGrow = 100;
				return (
					<div id={_id} data-xmlid={this.props.xml.id} className={"FormItemGroup"} ref={node => this.containerComponent = node} style={outStyle}>
						<div className="box-header with-border" style={innerStyle}>
							<h4 className="box-title" style={h4Style}>{this.state.label}</h4>
						</div>
						<div style={_style} className={layout=="vertical"?"verticalList":"horizontalList"}>{list}</div>
					</div>
				);
			}
		}
		
	}
};

FormItemGroup.defaultProps = {
};

export default FormItemGroup;


// WEBPACK FOOTER //
// ./src/formItem/FormItemGroup.js